// faq.js
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.faq-item');
  const toggleBtn = document.getElementById('toggle-faqs');
  const extra = document.querySelector('.extra-faq');

  function closeItem(item) {
    item.classList.remove('is-open');
    const ans = item.querySelector('.faq-answer');
    ans.classList.remove('open');
    item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
    ans.setAttribute('aria-hidden', 'true');
  }

  function openItem(item) {
    item.classList.add('is-open');
    const ans = item.querySelector('.faq-answer');
    ans.classList.add('open');
    item.querySelector('.faq-question').setAttribute('aria-expanded', 'true');
    ans.setAttribute('aria-hidden', 'false');
  }

  items.forEach(item => {
    const btn = item.querySelector('.faq-question');
    const ans = item.querySelector('.faq-answer');
    ans.classList.remove('open');
    ans.setAttribute('aria-hidden', 'true');

    btn.addEventListener('click', () => {
      if (item.classList.contains('is-open')) {
        closeItem(item);
      } else {
        items.forEach(other => { if (other !== item) closeItem(other); });
        openItem(item);
      }
    });
  });

  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      const isShown = extra.classList.toggle('show');
      toggleBtn.textContent = isShown ? 'Show Less' : 'View More';
      toggleBtn.setAttribute('aria-expanded', isShown ? 'true' : 'false');
      if (!isShown) {
        extra.querySelectorAll('.faq-item.is-open').forEach(it => closeItem(it));
      }
    });
  }
});
